"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pronunciationRange = pronunciationRange;
/** A range changes the reference, never the number of recordings. */
function pronunciationRange(text, first, last, selection) {
    if (!Number.isInteger(first) ||
        !Number.isInteger(last) ||
        first < 0 ||
        last < first ||
        last >= text.sentences.length) {
        throw new RangeError("Invalid pronunciation range");
    }
    const content = text.content ?? text.sentences.join(" ");
    if (selection) {
        const { start, end } = selection;
        if (!Number.isInteger(start) ||
            !Number.isInteger(end) ||
            start < 0 ||
            end <= start ||
            end > content.length ||
            !/[\p{L}\p{N}]/u.test(content.slice(start, end)))
            throw new RangeError("Invalid pronunciation selection");
        return {
            before: content.slice(0, start),
            reference: content.slice(start, end),
            after: content.slice(end),
        };
    }
    const ranges = text.sentenceRanges ??
        text.sentences.map((sentence, index) => {
            const start = text.sentences.slice(0, index).join(" ").length + (index ? 1 : 0);
            return { start, end: start + sentence.length };
        });
    const start = first === 0 ? 0 : ranges[first].start;
    const end = last === text.sentences.length - 1 ? content.length : ranges[last].end;
    return {
        before: content.slice(0, start),
        reference: content.slice(start, end),
        after: content.slice(end),
    };
}
//# sourceMappingURL=pronunciationRange.js.map